export default {
  methods: {
    scrollToTop(options = {}) {
      const {
        duration = 300,
        behavior = 'smooth',
        element = window
      } = options;

      if (behavior === 'smooth' && duration) {
        this.smoothScrollToTop(element, duration);
      } else {
        if (element === window) {
          window.scrollTo({ top: 0, behavior });
        } else {
          element.scrollTo({ top: 0, behavior });
        }
      }
    },

    smoothScrollToTop(element, duration) {
      const start = element === window ? window.pageYOffset : element.scrollTop;
      const startTime = performance.now();

      const scroll = (currentTime) => {
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1);

        const easeInOutQuad = progress < 0.5
          ? 2 * progress * progress
          : 1 - Math.pow(-2 * progress + 2, 2) / 2;

        const position = start * (1 - easeInOutQuad);

        if (element === window) {
          window.scrollTo(0, position);
        } else {
          element.scrollTop = position;
        }

        if (progress < 1) {
          requestAnimationFrame(scroll);
        }
      };

      requestAnimationFrame(scroll);
    },
  }
};
